import { render } from "./ParamInvoiceTaxRateDetail.vue?vue&type=template&id=fb774c5c&ts=true"
import script from "./ParamInvoiceTaxRateDetail.vue?vue&type=script&lang=ts"
export * from "./ParamInvoiceTaxRateDetail.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__